import { Component, OnInit } from '@angular/core';
import { MenuService } from '../../../services/menu.service';
import { DataIoService } from '../../../services/data-io.service';
import { IconBarService } from '../../../services/icon-bar.service';
import { NavBarService } from '../../../services/nav-bar.service';
import { MenuNode } from '../../../classes/MenuNode';
import { TimeFrameManager } from '../../../classes/TimeFrameManager';
import { TimeFrame } from '../../../classes/TimeFrame';
import { BaseSensor } from '../../../classes/BaseSensor';

@Component({
	selector: 'app-dash',
	templateUrl: './dash.component.html',
	styleUrls: ['./dash.component.scss']
})
export class DashComponent implements OnInit {
	mode:string=undefined;
	sensor:BaseSensor=undefined;
	hasControl:boolean=false;
	witterungsgefuehrt:boolean=false;
	constructor(
		private menuService:MenuService,
		private ioService:DataIoService,
		private iconbar:IconBarService,
		private navBar:NavBarService
	) {
		if(this.ioService){
			console.log("IOService exists");
		}
		if(this.ioService.deviceInfo()){
			console.log("deviceinfo exists");
		}

	}
	s():string{
		if(this.mode == 'absence'){
			return '1 ___';
		}
		return '';
	}
	getAlignment(){
		if(this.mode == 'absence'){
			return 'left';
		}
		return undefined;
	}

	b():string{
		if(this.mode == 'absence'){
			return " "+this.sensor.getCurrentElement();
		}
		if(this.hasControl && this.mode == 'heating'){
			return 'on';
		}
		if(this.witterungsgefuehrt){
			let tempFrame = this.ioService.deviceInfo().tempFrame;
			if(this.currentTimeframe){
				
				if(!tempFrame){
					return 'on';
				}else{
					return 'off';
				}
			}else{
				if(!tempFrame){
					return 'off';
				}else{
					return 'on';
				}
			}
		}
		if(this.ioService.getConfiguration().simulatorConfig.isStandalone()){
			if(this.currentTimeframe == undefined && this.ioService.deviceInfo().tempFrame == undefined){
				return 'off';
			}
			if(this.currentTimeframe != undefined && this.ioService.deviceInfo().tempFrame != undefined){
				return 'off';
			}
		}
		if(this.sensor.hasSpecialValue(this.sensor.getCurrentValue())){
			return this.sensor.getSpecialValue(this.sensor.getCurrentValue()).getReplacement()+"";
		}
		return this.sensor.getCurrentValue()+"";
	}
	unit():string{
		if(this.mode == 'absence'){
			return '';
		}
		if(this.hasControl && this.mode == 'heating'){
			return '';
		}
		if(this.witterungsgefuehrt){
			return '';
		}
		if(this.ioService.getConfiguration().simulatorConfig.isStandalone()){
			if(this.currentTimeframe == undefined && this.ioService.deviceInfo().tempFrame == undefined){
				return '';
			}
			if(this.currentTimeframe != undefined && this.ioService.deviceInfo().tempFrame != undefined){
				return '';
			}
		}
		if(this.sensor.hasSpecialValue(this.sensor.getCurrentValue())){
			return '';
		}
		return this.sensor.getRawUnit();
	}
	hasScale():boolean{
		if(this.hasControl){
			return false;
		}
		if(!this.timeControlled()){
			return false;
		}
		if(this.mode == 'heating'){
			if(this.ioService == undefined){
				console.warn('ioService is undefined.');
			}
			if(this.ioService.deviceInfo() == undefined){
				console.warn('ioService.deviceInfo() is undefined.');
			}
			
			return (this.ioService.deviceInfo().getDefaultZone().getRawValue('heatingmode')=='ENUM_HEATING_MODE_TIMECONTROLLED');
		}

		return false;
	}
	scaleType():string{
		return 'timeline';
	}
	getScaleElements():Array<number>{
		if(!this.hasScale()){
			return undefined;
		}
		let now = new Date();
		let day = now.getDay();
		day--;
		if(day == -1){
			day = 6;
		}
		
		let scale = this.ioService.deviceInfo().getDefaultZone().getTimeFrameManager('heating').getScale(day,48);
		let tf = this.ioService.getDeviceInfo().tempFrame;
		if(tf){
			let blinkMin = Math.round(48*tf.getStartRelative());
			let blinkMax = Math.round(48*tf.getEndRelative());
			console.log("Blinking from " + blinkMin+ " to " + blinkMax);
			if(blinkMin <= blinkMax){
				for(let i = blinkMin; i < blinkMax; i++){
					scale[i]=(this.currentTimeframe==undefined)?1:0;
				}
			}
		}
		return scale;
	}	
	currentTimeframe = undefined;
	_absence:false;
	absenceMode(){
		this.mode = 'absence';
		this.sensor = this.ioService.deviceInfo().getScale('absence');
		this.menuService.undisableButton('back');
		this.menuService.disableButton('menu');
		this.menuService.disableButton('timer');
		this.menuService.disableButton('up');
		this.menuService.disableButton('down');
		this.menuService.disableButton('slider');
		this.menuService.disableButton('dhw');
		this.menuService.disableButton('heating');
	}
	timeControlled():boolean{
		return this.ioService.getDeviceInfo().getValue('heizmodus')=='Zeitgesteuert';
	}
	init():void{
		this.navBar.disableAll();
		console.log("Init: Basic/Dash");
		let abs = this.ioService.deviceInfo().getScale('absence');
		if(abs.getCurrentValue() != 0){
			return this.absenceMode();
		}
		this.menuService.enableAllButtons();
		this.mode = this.ioService.deviceInfo().getRawValue('ai_mode');

		if(this.mode == 'heating'){

			let now = new Date();
			let day = now.getDay();
			day--;
			if(day == -1){
				day = 6;
			}
			let tfm :TimeFrameManager = this.ioService.deviceInfo().getDefaultZone().getTimeFrameManager('heating');
			let tf = tfm.getTimeFrame(day,now);
			this.currentTimeframe = tf;
			let tempFrame = this.ioService.deviceInfo().tempFrame;
			if(tf === null){
				if(!tempFrame){
					this.sensor = this.ioService.deviceInfo().getHeatingCircuitById(1).getScale('vorlaufsolltemp_absenkwunsch');
				}else{
					this.sensor = this.ioService.deviceInfo().getHeatingCircuitById(1).getScale('vorlaufsolltemp_wunsch');
				}
			}else{
				if(!tempFrame){
					this.sensor = this.ioService.deviceInfo().getHeatingCircuitById(1).getScale('vorlaufsolltemp_wunsch');
				}else{
					this.sensor = this.ioService.deviceInfo().getHeatingCircuitById(1).getScale('vorlaufsolltemp_absenkwunsch');
				}
			}
			if(!this.timeControlled()){
				this.sensor = this.ioService.deviceInfo().getScale('temp_temperature');
			}
			if(this.hasControl){
				this.menuService.disableButton('up');
				this.menuService.disableButton('down');			
				this.menuService.disableButton('slider');
			}
			if(this.ioService.deviceInfo().tempFrame != undefined){
				this.menuService.disableButton('up');
				this.menuService.disableButton('down');			
				this.menuService.disableButton('slider');
			}
		}
		if(this.mode == 'dhw'){
			this.sensor = this.ioService.deviceInfo().getScale('d006');
			if(this.hasControl){
				this.menuService.undisableButton('up');
				this.menuService.undisableButton('down');
				this.menuService.undisableButton('slider');
			}
		}

	}
	eventSubscription : any = undefined;


	ngOnInit() {
		this.witterungsgefuehrt = this.ioService.getConfiguration().simulatorConfig.witterungsgefuehrt();
		this.hasControl = this.ioService.getConfiguration().simulatorConfig.hasControl();
		this.init();
		this.iconbar.enable();
		this.iconbar.evaluate();
		console.error("OnInit on BaseDisplay called on Node: "+this.menuService.getCurrentNode().getIdentifier());
		this.eventSubscription = this.ioService.inputs.events$.subscribe( 
			(evt) => {
				if(['heating','dhw'].includes(evt)){
					this.init();
					return;
				}
				
				if(evt == 'back'){
					if(this.mode === 'absence'){
						this.mode = undefined;
						this.sensor.setCurrentValue(0);
						this.init();
						return;
					}
					if(this.ioService.deviceInfo().tempFrame != undefined){
						this.ioService.deviceInfo().tempFrame = undefined;
						this.menuService.undisableButton('up');
						this.menuService.undisableButton('down');			
						this.menuService.undisableButton('slider');
						this.init();
						return;
					}
					this.menuService.goto('idle');
				}
				if(['up','down'].includes(evt)){
					if(this.mode == 'dhw'){
						this.menuService.goto('quickset-desired-dhw');
						return;
					}
					if(this.mode == 'heating'){
						if(!this.timeControlled()){
							this.menuService.goto('desired-temperature');
						}else{
							this.menuService.goto('quickveto');
						}

						return;	
					}
					let heatingMode = this.ioService.deviceInfo().getDefaultZone().getRawValue('heatingmode');
					switch(heatingMode){
						case 'ENUM_HEATING_MODE_OFF':{
							return;
						}
						case 'ENUM_HEATING_MODE_MANUAL':{
							this.menuService.goto('desired-temperature');
							return;
						}
						case 'ENUM_HEATING_MODE_TIMECONTROLLED':{
							this.menuService.goto('quickset-desired-temperature');
							return;	
						}
						
					}
					
					return;
				}
				if(evt == 'menu'){
					console.log("Entering Waterpressure-Widget");
					let waterPressureNode = this.menuService.getCurrentNode().findFromRoot('waterpressure_widget');
					this.menuService.goto(waterPressureNode);
					return;
				}
				if(evt == 'confirm'){
					return;
				}
			}
		);
	}


	ngOnDestroy(){
		if(this.eventSubscription){
			this.eventSubscription.unsubscribe();
		}
		console.log("OnDestroy on BaseDisplay called on Node: "+this.menuService.getCurrentNode().getIdentifier());
	}
}
